module.exports = __webpack_public_path__ + "static/media/pray.763b84f7.svg";